<template>
    <div>        

        <Breadcrumbs main="Master" title="Tahun Ajaran"/>

        <!-- add modal -->
        <b-modal id="add-modal" title="Tambah Data Tahun Ajaran" hide-footer>
            <b-form class="needs-validation" @submit="handleSubmit">
                <div class="card-body">
                    <!-- mulai form periode -->
                    <div class="row">
                        <div class="col">
                            <div class="form-group">
                                <label>Tahun Ajaran</label>
                                <b-form-input type="text" v-model="form_data.tahun_ajaran" :state="form_data_result.tahun_ajaran" placeholder="Tahun Ajaran" ></b-form-input>
                                <b-form-invalid-feedback :state="form_data_result.tahun_ajaran" tooltip>Tahun Ajaran tidak boleh kosong.</b-form-invalid-feedback>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col">
                            <div class="form-group">
                                <label>Tahun Ujian</label>
                                <b-form-input type="text" v-model="form_data.tahun" :state="form_data_result.tahun" placeholder="Tahun Ujian" ></b-form-input>
                                <b-form-invalid-feedback :state="form_data_result.tahun" tooltip>Tahun Ujian tidak boleh kosong.</b-form-invalid-feedback>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col">
                            <div class="form-group">
                                <label>Nama Ujian</label>
                                <b-form-input type="text" v-model="form_data.name" :state="form_data_result.name" placeholder="Nama Ujian" ></b-form-input>
                                <b-form-invalid-feedback :state="form_data_result.name" tooltip>Nama Ujian tidak boleh kosong.</b-form-invalid-feedback>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col">
                            <div class="form-group">
                                <label>Tanggal Awal Ujian</label>
                                <b-form-input type="text" v-model="form_data.tanggal_ujian" :state="form_data_result.tanggal_ujian" placeholder="Tanggal Awal Ujian (DD MM YYYY)" ></b-form-input>
                                <b-form-invalid-feedback :state="form_data_result.tanggal_ujian" tooltip>Tanggal Awal Ujian tidak boleh kosong.</b-form-invalid-feedback>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col">
                            <div class="form-group">
                                <label>Tanggal Akhir Ujian</label>
                                <b-form-input type="text" v-model="form_data.tanggal_akhir_ujian" :state="form_data_result.tanggal_akhir_ujian" placeholder="Tanggal Akhir Ujian (DD MM YYYY)" ></b-form-input>
                                <b-form-invalid-feedback :state="form_data_result.tanggal_akhir_ujian" tooltip>Tanggal Akhir Ujian tidak boleh kosong.</b-form-invalid-feedback>
                            </div>
                        </div>
                    </div>
                    <!-- end form siswa -->                                                                
                </div>

                <div>
                    <b-button type="submit" variant="primary" class="mr-1">Submit</b-button>                                
                    <b-button type="reset" variant="danger" @click="cancelAdd">Cancel</b-button>
                </div>
            </b-form>
        </b-modal>

        <!-- Container-fluid starts-->
        <div class="container-fluid">
            <!-- list table siswa -->
            <div class="row">
                <div class="col-md-12">
					<div class="card">
						<div class="card-header">
							<h5 class="card-title">Daftar Tahun Ajaran</h5>
						</div>
						<div class="card-body">
                            <div style="display:flex; justify-content:space-between; align-items:center; width : 320px;" class="mb-2">
                                <b-button @click="addData" variant="primary" class="mr-1" size="sm" style="display:flex; justify-content:space-around; align-items:center; ">
                                    <feather type="plus" stroke="white"></feather> Tambah Data
                                </b-button>
                            </div>
							<div class="table-responsive datatable-vue m-0 vue-smart">
								<v-table
										:data="allPeriode" class="table"
										:currentPage.sync="basic.currentPage"
										:pageSize="10"
										@totalPagesChanged="basic.totalPages = $event"
								>
									<thead slot="head">
                                        <v-th>No</v-th>
                                        <v-th sortKey="tahun_ajaran">Tahun Ajaran</v-th>
                                        <v-th sortKey="tahun">Tahun Ujian</v-th>
                                        <v-th sortKey="name">Nama Ujian</v-th>
                                        <v-th sortKey="tanggal_ujian">Tanggal Awal Ujian</v-th>
                                        <v-th sortKey="tanggal_akhir_ujian">Tanggal Akhir Ujian</v-th>
                                        <v-th sortKey="status">Status</v-th>
                                        <v-th>Action</v-th>
									</thead>
									<tbody slot="body" slot-scope="{displayData}">
                                        <tr v-if="!allPeriode.length">
                                            <td colspan="6" style="text-align:center;">Belum Ada Data Tersedia</td>
                                        </tr>
                                        <tr v-else v-for="(row, index) in displayData" :key="row.id">
                                            <td>{{ index + 1 }}</td>
                                            <td v-if="index === indexEdit">
                                                <input type="text" v-model="form_data.tahun_ajaran">
                                            </td>
                                            <td v-else>{{ row.tahun_ajaran }}</td>

                                            <td v-if="index === indexEdit">
                                                <input type="text" v-model="form_data.tahun">
                                            </td>
                                            <td v-else>{{ row.tahun }}</td>

                                            <td v-if="index === indexEdit">
                                                <input type="text" v-model="form_data.name">
                                            </td>
                                            <td v-else>{{ row.name }}</td>

                                            <td v-if="index === indexEdit">
                                                <input type="text" v-model="form_data.tanggal_ujian">
                                            </td>
                                            <td v-else>{{ row.tanggal_ujian }}</td>
                                            
                                            <td v-if="index === indexEdit">
                                                <input type="text" v-model="form_data.tanggal_akhir_ujian">
                                            </td>
                                            <td v-else>{{ row.tanggal_akhir_ujian }}</td>
                                            <td v-if="index === indexEdit">                                                                                                
                                                <b-form-select v-model="form_data.status" :options="statusOptions"></b-form-select>
                                            </td>
                                            <td v-else>{{ getStatus(row.status) }}</td>
                                            <td>
                                                <div v-if="index === indexEdit" style="display:flex; justify-content:space-between; align-items:center; width:60px;">
                                                    <feather style="cursor:pointer;" type="save" stroke="blue" @click="saveData(row)"></feather>
                                                    <feather style="cursor:pointer;" type="x" stroke="red" @click="resetForm"></feather>
                                                </div>
                                                <div v-else style="display:flex; justify-content:space-between; align-items:center; width:60px;">
                                                    <feather style="cursor:pointer;" type="edit-2" stroke="blue" @click="editData(row, index)"></feather>
                                                    <feather style="cursor:pointer;" type="trash-2" stroke="red" @click="deleteData(row)"></feather>
                                                </div>
                                            </td>										
                                        </tr>
									</tbody>
								</v-table>

								<smart-pagination
										:currentPage.sync="basic.currentPage"
										:totalPages="basic.totalPages"
								/>
							</div>
						</div>
					</div>
				</div>
            </div>      
        </div>
        <!-- Container-fluid Ends-->
        <div class="loader" v-if="loader"></div>
    </div>
</template>

<script>
    import {url} from "@/urls";
    import {service} from '@/services';
    import * as _ from 'underscore';
    import { mapGetters } from 'vuex';

    export default {
        data(){
            return{
                indexEdit:-1,
                allPeriode: [],
                form_data:{
                    idtenant: localStorage.getItem("idtenant"),
                    name: '',
                    tahun: '',
                    tahun_ajaran: '',
                    tanggal_ujian: '',
                    tanggal_akhir_ujian: '',
                    status: true
                },
                form_data_result:{
                    name: null,
                    tahun: null,
                    tahun_ajaran: null,
                    tanggal_ujian: null,
                    tanggal_akhir_ujian: null
                },
                loader:false,

                basic:{
                    currentPage: 1,
                    totalPages: 0,
			    },
                statusOptions:[
                    { value:'t', text: 'Aktif'},
                    { value:'f', text: 'Tidak Aktif'}                
                ],
            }
        },
        methods: {
            cancelAdd() {
                this.$bvModal.hide('add-modal')
                this.resetForm()
            },
            addBulkData() {
                this.$bvModal.show('bulk-upload-modal')
            },
            addData() {
                this.$bvModal.show('add-modal')
            },
            saveData(data) {                
                // jika masih ada yang aktif alert
                var canEditPeriode = true

                if (this.form_data.status === 't' && !data.status) {
                    var i = 0                
                    for (i=0;i<this.allPeriode.length;i++) {
                        if (this.allPeriode[i].status) {
                            canEditPeriode = false
                            break 
                        }
                    }
                }                

                if (canEditPeriode) {
                    this._saveData(data)
                } else {
                    this.$toasted.show(" Tidak dapat edit periode, masih ada periode yang aktif. ", {theme: 'outline',position: "top-right", type: 'error', duration: 3000});
                }
            },
            _saveData(data) {
                console.log(this.$data.form_data)
                this.loader = true;
                // this.form_data.password = this.form_data.nis;
                let body = {
                    name: this.form_data.name,
                    tahun: this.form_data.tahun,
                    tahun_ajaran: this.form_data.tahun_ajaran,
                    tanggal_ujian: this.form_data.tanggal_ujian,
                    tanggal_akhir_ujian: this.form_data.tanggal_akhir_ujian,
                    status: this.form_data.status,
                }
                console.log(body)

                service.onUpdate(`${url.master_periode}/${data.id}`, body)
                .then(result => {
                    setTimeout(() => {
                        this.loader = false;
                        this.$toasted.show(" Tahun Ajaran berhasil diubah ", {theme: 'outline',position: "top-right", type: 'success', duration: 3000});
                    }, 1000);                        
                    console.log(result.data);
                    this.getAllPeriodeByTenant()
                    this.resetForm()
                    // this.cancelAdd()					
                }).catch(error => {
                    setTimeout(() => {
                        // eslint-disable-next-line
                        console.log(error);
                        this.$toasted.show(" Terjadi kesalahan input, silahkan diulangi kembali ", {theme: 'outline',position: "top-right", type: 'error', duration: 3000});
                        this.loader = false;
                    }, 1000);
                    // this.cancelAdd()
                    this.resetForm()
                })
            },
            deleteData(data) {
                this.$swal({
                    icon: 'warning',
                    title: `Apakah anda yakin`,
                    text : `ingin menghapus data ${data.name} ?`,
                    showCancelButton: true,
                    cancelButtonText: `Tidak`,
                    confirmButtonText: `Ya`,
                }).then((res) => {
                    if (res.isConfirmed) {
                        service.onDelete(`${url.master_periode}/${data.id}`)
                        .then((resultDelete) => {
                            if (resultDelete) {
                                this.$swal(
                                    'Terhapus!',
                                    'Data berhasil dihapus.',
                                    'success'
                                )
                                this.getAllPeriodeByTenant()
                            }
                        })
                        // eslint-disable-next-line
                        .catch((errDelete) => {
                            this.$swal({
                                icon: 'error',
                                title: 'Oops...',
                                text: 'Terjadi Kesalahan!',
                            })
                        })
                    }
                })
            },
            editData(data, index) {
                const { name, tahun, tahun_ajaran, tanggal_ujian, tanggal_akhir_ujian, status } = data                
                this.$data.form_data.idtenant = this.getTenant
                this.$data.form_data.name = name
                this.$data.form_data.tahun = tahun
                this.$data.form_data.tahun_ajaran = tahun_ajaran
                this.$data.form_data.tanggal_ujian = tanggal_ujian
                this.$data.form_data.tanggal_akhir_ujian = tanggal_akhir_ujian
                this.$data.form_data.status = status ? "t" : "f"
                this.$data.indexEdit = index
                
                // this.$bvModal.show('edit-modal')
            },
            handleSubmit(evt) {
                evt.preventDefault()

                // jika masih ada yang aktif alert
                var i = 0
                var canAddNewPeriode = true
                for (i=0;i<this.allPeriode.length;i++) {
                    if (this.allPeriode[i].status) {
                        canAddNewPeriode = false
                        break 
                    }
                }

                if (canAddNewPeriode) {
                    if(this.form_data.name && this.form_data.tahun && this.form_data.tahun_ajaran && this.form_data.tanggal_ujian )
                    {
                        this.form_data_result.name = true
                        this.form_data_result.tahun = true
                        this.form_data_result.tahun_ajaran = true
                        this.form_data_result.tanggal_ujian = true
                        this.form_data_result.tanggal_akhir_ujian = true
                    }
                    else
                    {
                        this.form_data_result.name = false
                        this.form_data_result.tahun = false
                        this.form_data_result.tahun_ajaran = false
                        this.form_data_result.tanggal_ujian = false
                        this.form_data_result.tanggal_akhir_ujian = false
                    }

                    if (this.form_data_result.name && this.form_data_result.tahun && this.form_data_result.tahun_ajaran && this.form_data_result.tanggal_ujian && this.form_data_result.tanggal_akhir_ujian) {
                        this.loader = true;
                    
                        let body = _.clone(this.form_data);
                        console.log(body);

                        service.onPost(url.master_periode, body)
                        .then(result => {
                            setTimeout(() => {
                                this.loader = false;
                                this.$toasted.show(" Periode berhasil disimpan ", {theme: 'outline',position: "top-right", type: 'success', duration: 3000});
                            }, 1000);                        
                            console.log(result.data);
                            this.getAllPeriodeByTenant()
                            this.cancelAdd()					
                        }).catch(error => {
                            setTimeout(() => {
                                // eslint-disable-next-line
                                console.log(error);
                                this.$toasted.show(" Terjadi kesalahan input, silahkan diulangi kembali ", {theme: 'outline',position: "top-right", type: 'error', duration: 3000});
                                this.loader = false;
                            }, 1000);
                            this.cancelAdd()
                        })
                    }
                } else {
                    this.$toasted.show(" Tidak dapat membuat periode baru, masih ada periode yang aktif. ", {theme: 'outline',position: "top-right", type: 'error', duration: 3000});
                }
                
            },
            getAllPeriodeByTenant(){
                this.loader = true;

                service.onGet(url.master_periode_get_by_tenant + "/" + localStorage.getItem("idtenant"))
                .then(result => {
                    console.log(result.data);
                    this.loader = false;
                    if (result.data) {
                        this.allPeriode = result.data;
                        //this.questions = JSON.parse(result.data.fullquestion);
                    }
                }).catch(error => {
                    this.loader = false;
                    console.log(error)
                })
            },
            resetForm() {
                this.$data.form_data.idtenant = localStorage.getItem("idtenant")
                this.$data.form_data.name = ''
                this.$data.form_data.tahun = ''
                this.$data.form_data.tahun_ajaran = ''
                this.$data.form_data.tanggal_ujian = ''
                this.$data.form_data.tanggal_akhir_ujian = ''
                this.form_data_result.name = null
                this.form_data_result.tahun = null
                this.form_data_result.tahun_ajaran = null
                this.form_data_result.tanggal_ujian = null
                this.form_data_result.tanggal_akhir_ujian = null
                this.$data.indexEdit = -1
            },
            getStatus: function (status) {                   
                return status ? "Aktif" : "Tidak Aktif";
            }
        },
        mounted() {
            this.getAllPeriodeByTenant();
            // console.log(this.tenant, "periode")
        },
        computed: {
            ...mapGetters({
                tenant: 'user/getCurrentTenant'
            }),
        } 
    }
</script>
<style lang="scss" scoped>

</style>